export const MAP_VIEWER_ROLE = 'map-viewer';
